import { render, staticRenderFns } from "./base-table-list.vue?vue&type=template&id=6fb7a246&scoped=true&"
import script from "./base-table-list.vue?vue&type=script&lang=js&"
export * from "./base-table-list.vue?vue&type=script&lang=js&"
import style0 from "./base-table-list.vue?vue&type=style&index=0&id=6fb7a246&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb7a246",
  null
  
)

export default component.exports